import { render } from "./404.vue?vue&type=template&id=3a57b1b2&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=3a57b1b2&lang=scss&scoped=true"

import exportComponent from "/Users/shuaqq/Desktop/jysports/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a57b1b2"]])

export default __exports__